module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"tooltip":{"backoffice":"Retornar ao backoffice","account":"Selecionar Conta"},"status":{"test":"Teste","inactive":"Inativo","blocked":"Bloqueado","active":"Ativo","pending":"Pendente"}},"en-US":{"tooltip":{"backoffice":"Return to Backoffice","account":"Select Account"},"status":{"test":"Test","inactive":"Inactive","blocked":"Blocked","pending":"Pending"}}}')
  delete Component.options._Ctor
}
